import { zodResolver } from "@hookform/resolvers/zod"
import { useNavigate } from "@tanstack/react-router"
import axios from "axios"
import { useCreateWhatsappTemplateMutation } from "modules/campaigns/hooks/sections/whatsapp/useCreateWhatsappTemplateMutation"
import { WhatsappTemplateFormSchema } from "modules/campaigns/lib/whatsappTemplateFormSchema"
import { useState } from "react"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { SearchSchema } from "routes/_base/_auth/settings/channels/whatsapp/templates"
import { CreateWhatsappTemplateSchema, Errors } from "schema"
import { toast } from "sonner"
import { z } from "zod"
import { WhatsappMessageCreator } from "./WhatsappMessageCreator"

export const WhatsappTemplateCreate = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const { mutateAsync } = useCreateWhatsappTemplateMutation()
  const form = useForm<z.infer<typeof CreateWhatsappTemplateSchema>>({
    resolver: zodResolver(WhatsappTemplateFormSchema),
    defaultValues: {
      template: {
        name: "",
        language: undefined,
        header: "",
        body: "",
        footer: "",
        buttons: [],
        category: "UTILITY",
      },
    },
    disabled: isLoading,
  })

  const onSubmit = (data: z.infer<typeof CreateWhatsappTemplateSchema>) => {
    setIsLoading(true)
    mutateAsync({ props: data })
      .then(() => {
        navigate({ to: "/settings/channels/whatsapp/templates", search: SearchSchema.parse({}) })
        toast.success(t("campaigns.templates.whatsapp.success.whatsapp.create"))
      })
      .catch((error: unknown) => {
        setIsLoading(false)

        if (
          axios.isAxiosError<{ error?: { key?: string } }>(error) &&
          error.response?.data.error?.key === Errors.WHATSAPP_TEMPLATE_VARIABLE_AT_EDGE
        ) {
          form.setError("template.body", {
            type: "server",
            message: Errors.WHATSAPP_TEMPLATE_VARIABLE_AT_EDGE,
          })
        }
      })
  }

  return <WhatsappMessageCreator form={form} onSubmit={onSubmit} mode="create" />
}
